import React from "react";
import "../PagesCss/AreasAtuacao.css";
import BotaoWhatsapp from "../../component/BotaoWhatsapp";
import CTAWhatsapp from "../../component/CTAWhatsapp";

function IndenizacaoPerdas() {
  return (
    <section className="area-page">
      <h1>Indenização por Perdas e Danos em Execuções Rurais</h1>

      <p>
        Infelizmente a grande maioria dos produtores rurais não conhecem seus
        direitos.
      </p>

      <p>
        Por isso, muitas vezes as instituições financeiras cometem excessos que
        acabam "passando em branco" já que, se o produtor não conhece a lei, ele
        não tem como exigir que ela seja cumprida.
      </p>

      <p>
        Os casos mais comuns de violação de direitos são a realização de leilão
        de imóveis ou implementos rurais que eram impenhoráveis e, portanto,
        jamais poderiam ter sido expropriados, e a negativação ilegal do nome de
        produtores em razão da cobrança de juros e encargos acima do permitido
        pelo Manual de Crédito Rural do Conselho Monetário Nacional (CMN).
      </p>

      <p>
        Se você quer descobrir se tem direito de ser indenizado em razão da
        prática de atos ilícitos por instituições financeiras em execuções
        rurais, ou quer mais informações sobre esse assunto, clique no botão
        abaixo para falar gratuitamente com nossos especialistas, direto no seu
        WhatsApp.
      </p>

      <CTAWhatsapp text="Fale com um especialista" />

      <BotaoWhatsapp />
    </section>
  );
}

export default IndenizacaoPerdas;
